import * as THREE from "three";
import { SceneData } from "./types";
import {
  createGround,
  createBuilding,
  createRoad,
  createTree,
  createVehicle,
  createPerson,
} from "./geometry";
import defaultSceneData from "./data/scene.json";

export function loadScene(): SceneData {
  return defaultSceneData as SceneData;
}

export function populateScene(
  scene: THREE.Scene,
  data: SceneData
): void {
  scene.add(createGround(data.ground));

  for (const b of data.buildings) {
    scene.add(createBuilding(b));
  }

  for (const r of data.roads) {
    scene.add(createRoad(r));
  }

  for (const t of data.trees) {
    scene.add(createTree(t));
  }

  for (const v of data.vehicles) {
    scene.add(createVehicle(v));
  }

  for (const p of data.people) {
    scene.add(createPerson(p));
  }
}
